class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.recentSearchesContainer = this.querySelector('[data-recent-searches]');
    this.beforeOpenContainer = this.querySelector('[data-before-open]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

setupEventListeners() {
  this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
  this.input.addEventListener('focus', this.onFocus.bind(this));
  this.addEventListener('focusout', this.onFocusOut.bind(this));
  this.addEventListener('keyup', this.onKeyup.bind(this));
  this.addEventListener('keydown', this.onKeydown.bind(this));

  // ✅ Hide both recent search UI and predictive results when reset clears input
this.input.form.addEventListener('reset', () => {
  requestAnimationFrame(() => {
    this.input.value = '';
    this.removeAttribute('beforeopen');
    this.close(true);
    document.querySelector('[data-before-open]')?.setAttribute('hidden', true);
  });
});

}


  getQuery() {
    return this.input.value.trim();
  }

  onFocus() {
    this.setAttribute('beforeopen', 'true');

    const currentSearchTerm = this.getQuery();
    if (!currentSearchTerm.length) {
      this.renderRecentSearches(); // Show recent only when empty
      return;
    }

    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onChange() {
    super.onChange();
    this.removeAttribute('beforeopen');

    if (this.beforeOpenContainer) this.beforeOpenContainer.setAttribute('hidden', true);

    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    this.updateSearchForTerm(this.searchTerm, newSearchTerm);
    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    const term = this.getQuery();
    if (!term || this.querySelector('[aria-selected="true"] a')) {
      event.preventDefault();
      return;
    }

    let recent = JSON.parse(localStorage.getItem('recentSearches')) || [];
    recent = recent.filter(t => t !== term);
    recent.unshift(term);
    if (recent.length > 5) recent = recent.slice(0, 5);
    localStorage.setItem('recentSearches', JSON.stringify(recent));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.removeAttribute('beforeopen');
        if (this.beforeOpenContainer) this.beforeOpenContainer.setAttribute('hidden', true);
        this.close();
      }
    });
  }

  renderRecentSearches() {
    const recent = JSON.parse(localStorage.getItem('recentSearches')) || [];

    if (!recent.length || !this.recentSearchesContainer || !this.beforeOpenContainer) {
      this.recentSearchesContainer?.setAttribute('hidden', true);
      this.beforeOpenContainer?.setAttribute('hidden', true);
      return;
    }

    this.recentSearchesContainer.innerHTML = recent.map(term => `
      <li>
        <button type="button" class="recent-search-item" data-term="${term}">${term}</button>
      </li>`).join('');

    this.recentSearchesContainer.removeAttribute('hidden');
    this.beforeOpenContainer.removeAttribute('hidden');

    this.recentSearchesContainer.querySelectorAll('.recent-search-item').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const term = e.currentTarget.getAttribute('data-term');
        this.input.value = term;
        this.removeAttribute('beforeopen');
        this.beforeOpenContainer?.setAttribute('hidden', true);
        this.getSearchResults(term);
      });
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp': this.switchOption('up'); break;
      case 'ArrowDown': this.switchOption('down'); break;
      case 'Enter': this.selectOption(); break;
    }
  }

  onKeydown(event) {
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const el = this.querySelector('[data-predictive-search-search-for-text]');
    const txt = el?.innerText;
    if (txt && txt.match(new RegExp(previousTerm, 'g'))?.length <= 1) {
      el.innerText = txt.replace(previousTerm, newTerm);
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;
    const moveUp = direction === 'up';
    const selected = this.querySelector('[aria-selected="true"]');
    const options = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(e => e.offsetParent !== null);

    let selectedIndex = options.indexOf(selected);
    if (moveUp && !selected) return;

    let newIndex = moveUp
      ? (selectedIndex === 0 ? options.length - 1 : selectedIndex - 1)
      : (selectedIndex === options.length - 1 ? 0 : selectedIndex + 1);

    if (newIndex === selectedIndex) return;

    if (selected) selected.setAttribute('aria-selected', false);
    const active = options[newIndex];
    active.setAttribute('aria-selected', true);
    this.input.setAttribute('aria-activedescendant', active.id);
  }

  selectOption() {
    const selected = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
    if (selected) selected.click();
  }

  getSearchResults(searchTerm) {
    const key = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[key]) {
      this.renderSearchResults(this.cachedResults[key]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.status);
        return res.text();
      })
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.allPredictiveSearchInstances.forEach(inst => inst.cachedResults[key] = html);
        this.renderSearchResults(html);
      })
      .catch((err) => {
        if (err?.code !== 20) this.close();
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(text) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = text;
    setTimeout(() => this.statusElement.setAttribute('aria-hidden', 'true'), 1000);
  }

  renderSearchResults(markup) {
    this.predictiveSearchResults.innerHTML = markup;
    this.setAttribute('results', true);
    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]')?.textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clear = false) {
    this.closeResults(clear);
    this.isOpen = false;
  }

  closeResults(clear = false) {
    if (clear) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    this.querySelector('[aria-selected="true"]')?.setAttribute('aria-selected', false);
    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);
